(function () {
  function unClamp(el) {
    if (!el) return;
    el.style.setProperty('max-height', 'none', 'important');
    el.style.setProperty('height', 'auto', 'important');
    el.style.setProperty('overflow', 'visible', 'important');
    el.style.setProperty('opacity', '1', 'important');
    el.style.setProperty('-webkit-line-clamp', 'unset', 'important');
    el.style.setProperty('-webkit-mask-image', 'none', 'important');
    el.style.setProperty('mask-image', 'none', 'important');
  }

  function initLongText(wrap) {
    var more  = wrap.querySelector('.read-more-btn');
    var less  = wrap.querySelector('.read-less-btn');
    var short = wrap.querySelector('.short-content');
    var full  = wrap.querySelector('.full-content');
    if (!more || !short || !full) return;

    // Sauvegarde HTML d'origine (une seule fois)
    if (!wrap.__orig) {
      wrap.__orig = {
        shortHTML: short.innerHTML,
        fullHTML:  full.innerHTML
      };
    }

    // État initial
    full.style.display = 'none';
    if (less) less.style.display = 'none';
    more.style.display = 'inline';
    unClamp(short);

    // Boutons de type "button"
    if (!more.getAttribute('type')) more.setAttribute('type', 'button');
    if (less && !less.getAttribute('type')) less.setAttribute('type', 'button');

    // Handler Voir plus
    more.onclick = function (e) {
      e.preventDefault();

      // 1) Reconstruire le HTML fusionné SANS les boutons
      var tmpShort = document.createElement('div');
      tmpShort.innerHTML = wrap.__orig.shortHTML;
      tmpShort.querySelectorAll('.read-more-btn').forEach(function(n){ n.remove(); });

      var tmpFull = document.createElement('div');
      tmpFull.innerHTML = wrap.__orig.fullHTML;
      tmpFull.querySelectorAll('.read-less-btn').forEach(function(n){ n.remove(); });

      short.innerHTML = tmpShort.innerHTML + tmpFull.innerHTML;
      unClamp(short);
      full.style.display = 'none';

      // 2) Déplacer le vrai bouton "Voir moins" (celui qui a déjà le listener)
      //    dans la zone visible, puis l'afficher
      if (!less) { less = wrap.querySelector('.read-less-btn'); }
      if (less) {
        short.appendChild(less);
        less.style.setProperty('display', 'inline', 'important');

        // Handler Voir moins (restaure l'état d'origine)
        less.onclick = function (ev) {
          ev.preventDefault();
          short.innerHTML = wrap.__orig.shortHTML;
          full.innerHTML  = wrap.__orig.fullHTML;
          full.style.display = 'none';
          unClamp(short);

          // Ré-initialiser les références et listeners sur les nouveaux nœuds
          initLongText(wrap);
        };
      }

      // 3) S'assurer qu'aucun "Voir plus" résiduel n'est visible
      short.querySelectorAll('.read-more-btn').forEach(function(n){ n.remove(); });
      more.style.setProperty('display', 'none', 'important');
    };
  }

  function initAll() {
    var blocks = document.querySelectorAll('.long-text');
    for (var i = 0; i < blocks.length; i++) initLongText(blocks[i]);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();

